import { Link } from "react-router-dom";
import { Bookmark } from "lucide-react";
import { useEffect } from "react";
import { useSaved } from "@/hooks/useSaved";
import { NewsCard } from "@/components/news/NewsCard";

export default function SavedPage() {
  const { saved } = useSaved();
  useEffect(() => { document.title = "Guardados | Notícia 365"; }, []);
  return (
    <div className="mx-auto max-w-7xl px-4 pt-8 sm:px-6 lg:px-8">
      <h1 className="font-serif-display text-4xl font-black sm:text-5xl">Guardados</h1>
      <p className="mt-2 text-muted-foreground">As notícias que guardou para ler mais tarde, neste dispositivo.</p>
      {saved.length === 0 ? (
        <div data-testid="saved-empty-state" className="mt-16 flex flex-col items-start gap-4 rounded-2xl border border-dashed p-10">
          <Bookmark size={36} className="text-primary" />
          <p className="font-serif-display text-xl font-bold">Ainda não guardou nenhuma notícia.</p>
          <Link to="/" data-testid="saved-go-home-link" className="rounded-full bg-primary px-6 py-3 text-sm font-bold text-white">Explorar notícias</Link>
        </div>
      ) : (
        <div data-testid="saved-list" className="mt-10 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">{saved.map((a, i) => <NewsCard key={a.id} a={a} i={i} />)}</div>
      )}
    </div>
  );
}
